'use es6';

import { adClickedEventDeprecation } from './adClickedEventDeprecation';
import { usesCurrentlyInWorkflowProperty } from './usesCurrentlyInWorkflowContactProperty';
export default {
  adClickedEventDeprecation,
  usesCurrentlyInWorkflowProperty
};